import customProtocolCheck from 'custom-protocol-check';
import { APP_CUSTOM_PROTOCOL, APP_CUSTOM_PROTOCOL_CHECK_TIMEOUT } from '@/deepLinks/constants';
import { computed, ref } from 'vue';

export const useCheckProtocol = ({ isInitialized, link }) => {
  const deepLink = computed(() => {
    const { href, protocol } = new URL(link.value);
    return href.replace(protocol, `${APP_CUSTOM_PROTOCOL}:` );
  });

  const isAppInstalled = ref(false);
  const isCheckSupported = ref(false);
  const checkTimeout = ref(null);

  const cancelTimeout = () => {
    clearTimeout(checkTimeout.value);
    checkTimeout.value = null;
  };

  const onCheckFailed = () => {
    isAppInstalled.value = false;
    isCheckSupported.value = true;
    isInitialized.value = true;
    cancelTimeout();
  };

  const onCheckSuccess = () => {
    isAppInstalled.value = true;
    isCheckSupported.value = true;
    isInitialized.value = true;
    cancelTimeout();
  };

  const onCheckUnsupported = () => {
    isCheckSupported.value = false;
    isInitialized.value = true;
    cancelTimeout();
  };

  const checkProtocol = () => {
    //fallback for weird cases in mobile browsers
    checkTimeout.value = setTimeout(onCheckUnsupported, APP_CUSTOM_PROTOCOL_CHECK_TIMEOUT + 500);

    try {
      customProtocolCheck(
        deepLink.value,
        onCheckFailed,
        onCheckSuccess,
        APP_CUSTOM_PROTOCOL_CHECK_TIMEOUT,
        onCheckUnsupported,
      );
    } catch (e) {
      onCheckUnsupported();
    }
  };

  return { isAppInstalled, isCheckSupported, checkProtocol, deepLink };
};